import { render, staticRenderFns } from "./StudentScholarshipApproval.vue?vue&type=template&id=01ccd6a1&scoped=true"
import script from "./StudentScholarshipApproval.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipApproval.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipApproval.vue?vue&type=style&index=0&id=01ccd6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ccd6a1",
  null
  
)

export default component.exports